import AxiosClient from "../../../services/axios.services";

class MonitorServices {
  getMonitor = (params) =>
    AxiosClient.get("/api/app/On_off_bording_monitor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  saveCopia = (data) =>
    AxiosClient.post("/api/app/Copia_masiva_workflow/", data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteWorkflow = (id) =>
    AxiosClient.delete(`/api/app/On_off_bording_eliminar_workflow/${id}`, {
      headers: { "Content-Type": "application/json" },
    });

  saveDadoDeBaja = (data) =>
    AxiosClient.post("/api/app/actualizar_dato_dado_baja/", data, {
      headers: { "Content-Type": "application/json" },
    });
  getBoardingManual = (id) =>
    AxiosClient.get(`/api/app/documento_onoffboarding/${id}/`, {
      headers: { responseType: "blob" },
    });
  // AxiosClient.get(`/api/app/documento_onoffboardingViewset/${id}/`, {
  //   headers: { responseType: "blob" },
  // });
}

export default new MonitorServices();
